import React from 'react';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';

import styles from './ThumbnailButton.module.scss';

const ThumbnailButton = () => (
  <span className={styles.btn}>
    <ImageOutlinedIcon />
  </span>
);

export default ThumbnailButton;
